var map = {
	"./5G.png": "9ed2",
	"./XLV.png": "16e4",
	"./cienciacasa.png": "ca18",
	"./cocina.png": "67b1",
	"./covid.png": "4c3e",
	"./desayuno.png": "3713",
	"./energia.png": "3b7b",
	"./fotones.png": "95c4",
	"./jugandoaprendo.png": "0c38",
	"./parasitosis.png": "ea5b",
	"./quimiclean.png": "e500",
	"./secretosorina.png": "eb9e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "754c";